export const VIEW_TYPES = {
    DAILY: 1,
    SEVEN_DAY: 7,
    FOURTEEN_DAY: 14,
};

export const DATE_MODES = {
    INIT: 0,
    NEXT: 1,
    PREVIOUS: 2,
};

export const STATUS = {
    CONNECTED: 'CONNECTED',
    NOT_CONNECTED: 'NOT_CONNECTED',
    LAPSED: 'LAPSED',
};

export const SYNC_STATUS = {
    INVALID: 0,
    AUTHORIZED: 1,
    NOT_AUTHORIZED: 2, // Members that are not stored in Livongo's db have NOT_AUTHORIZED status implicitly
    REVOKED: 3,
};

export const UNDERSTAND_URL = {
    'en-US':
        'https://www.teladochealth.com/library/article/understanding-your-cgm-data',
    'es-US':
        'https://www.teladochealth.com/es-us/library/article/understanding-your-cgm-data',
};

export const BACK_LIMIT_DAYS = 180; // The maximum number of days a member can go back to view their CGM data, based on the data retention policy

export const LINK_TYPES = {
    COACH_DASHBOARD: 'COACH_DASHBOARD',
    MANAGE_FOOD_INSIGHTS: 'MANAGE_FOOD_INSIGHTS',
    STEP_SYNC: 'STEP_SYNC',
};

export const DEEP_LINK = 'mobile_deep_link';

export const TARGET_RANGE = {
    RANGE: {
        LOW: 70,
        HIGH: 180,
    },
    TYPE: {
        BOX: 'box',
        LINE: 'line',
    },
    DRAW_TIME: {
        BEFORE_DATASETS_DRAW: 'beforeDatasetsDraw',
    },
};

export const GRAPH_COLOR = {
    TOOLTIP: {
        DIVIDER: '#ffffff70',
        VERTICAL_LINE: '#949292',
        BACKGROUND: '#1a1a1a',
        TEXT: '#ffffff',
    },
    TARGET_RANGE: {
        BORDER: '#4caf50',
        BACKGROUND: '#E8F5E999',
    },
    LINE_CHART: {
        LINE_COLOR: '#4d3a7d',
        POINT_HOVER_BACKGROUND_COLOR: '#4d3a7d',
    },
    SCALE: {
        X_LABEL: '#414040',
        Y_LABEL: '#414040',
        GRID: '#e0e0e0',
        NO_LINE_GRID: 'transparent',
    },
    BAR_CHART: {
        DEFAULT_BAR_COLOR: '#846EFF',
        ACTIVE_BAR_COLOR: '#462575',
        SCALE_X_BORDER: '#ddd',
    },
};

export const LABEL_BOLD = {
    REGULAR: '400',
    BOLD: '800',
};

export const POSITION = {
    TOP_FIXED: 'topFixed',
};

export const SCALE_Y = {
    POINT_LOWEST: 40,
    POINT_HIGHEST: 250,
    TARGET_LOW: 70,
    TARGET_HIGH: 180,
};

export const CHART_EVENTS = ['mousemove', 'click', 'touchstart', 'touchmove'];

export const TOOLTIP_TOP_OFFSET = 70;

export const UNIT = 'mg/dL';

export const KEYBOARD_NAVIGATION = {
    LEFT_ARROW: 'ArrowLeft',
    RIGHT_ARROW: 'ArrowRight',
    ESCAPE: 'Escape',
};

export const OVERVIEW_STATES = 'CGM_OVERVIEW_STATES';

export const SYNC_YOUR_CGM_ID = 'SYNC_YOUR_CGM_ID';
export const SYNC_YOUR_CGM = 'SYNC_YOUR_CGM';
export const ACTIVATE_DEVICES = 'ACTIVATE_DEVICES';

export const BAR_GRAPH_BLOCK_ORDER = {
    overnight: 'OVERNIGHT',
    morning: 'MORNING',
    afternoon: 'AFTERNOON',
    evening: 'EVENING',
};

export const BAR_TOOLTIP = {
    minWidth: 172,
    paddingX: 12,
    paddingY: 10,
    edgePadding: 8,
    offsetY: 6,
    caretHeight: 6,
    caretWidth: 12,
    caretPadding: 14,
    radius: 6,
    titleFont: '700 13px sans-serif',
    labelFont: '400 13px sans-serif',
    valueFont: '700 13px sans-serif',
    titleHeight: 16,
    titleDividerSpacing: 8,
    bodyTopSpacing: 10,
    rowHeight: 16,
    rowGap: 4,
    columnGap: 16,
};

export const LINE_TOOLTIP = {
    enabled: true,
    position: POSITION.TOP_FIXED,
    backgroundColor: GRAPH_COLOR.TOOLTIP.BACKGROUND,
    padding: 12,
    titleMarginBottom: 15, // moves label down by 15px
    displayColors: false,
};

export const BAR_GRAPH_TIME_BLOCKS = [
    ['12 AM', '6 AM'],
    ['6 AM', '12 PM'],
    ['12 PM', '6 PM'],
    ['6 PM', '12 AM'],
];
